<template>
  <div
    style="text-align: right;"
  >
    <el-dropdown
      ref="dropDown"
      size="small"
      @command="handleAction"
    >
      <el-button
        size="mini"
        class="el-dropdown-link"
        @click.stop="toggleDropDown"
      >
        <i :class="!buttonLoader ? 'el-icon-more' : 'el-icon-loading'" />
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-can="'supplierorder.create'"
          :command="copySupplierOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-document-copy" /> Másolás
        </el-dropdown-item>
        <el-dropdown-item
          v-can="'supplierorder.update'"
          v-if="supplierOrder.status === 'cancelled'"
          :command="undoCancelSupplierOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-refresh-left" /> Lemondás visszavonása
        </el-dropdown-item>
        <el-dropdown-item
          v-can="'supplierorder.update'"
          v-if="supplierOrder.status === 'sent'"
          :command="cancelSupplierOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-close" /> Megrendelés lemondása
        </el-dropdown-item>
        <el-dropdown-item
          v-can="'supplierorder.update'"
          v-if="supplierOrder.status === 'recorded'"
          :command="sendSupplierOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-s-promotion" /> Megrendelés elküldése
        </el-dropdown-item>
        <el-dropdown-item
          v-can="'supplierorder.update'"
          :command="updateSupplierOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-edit" /> Módosítás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="supplierOrder.status === 'recorded'"
          v-can="'supplierorder.delete'"
          :command="openDeleteConfirmation"
          :disabled="buttonLoader"
        >
          <i class="el-icon-delete" /> Törlés
        </el-dropdown-item>
        <el-dropdown-item
          :command="exportExcel"
          :disabled="buttonLoader"
        >
          <i class="el-icon-download" /> Excel exportálás
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  export default {
    props: ['supplierOrder'],
    data() {
      return {
        buttonLoader: false,
        deleteConfirmVisible: false,
      };
    },

    methods: {
      displayDeleteConfirmation() {
        this.deleteConfirmVisible = true
      },
      async deleteSupplierOrder() {
        this.buttonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('supplierOrder/delete', this.supplierOrder.id);
          this.$store.dispatch('supplierOrder/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      async updateSupplierOrder() {
        this.$router.push('/processes/supplier-orders/update/' + this.supplierOrder.id);
      },
      async copySupplierOrder() {
        this.$router.push('/processes/supplier-orders/add/' + this.supplierOrder.id);
      },
      async sendSupplierOrder() {
        this.buttonLoader = true;
        try {
          await this.$store.dispatch('supplierOrder/send', this.supplierOrder.id);
          this.$store.dispatch('supplierOrder/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      async cancelSupplierOrder() {
        this.buttonLoader = true;
        try {
          await this.$store.dispatch('supplierOrder/cancel', this.supplierOrder.id);
          this.$store.dispatch('supplierOrder/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      async undoCancelSupplierOrder() {
        this.buttonLoader = true;
        try {
          await this.$store.dispatch('supplierOrder/undoCancel', this.supplierOrder.id);
          this.$store.dispatch('supplierOrder/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      async openReceipt() {
        if (this.supplierOrder.receipt_path) {
          try {
            const url = await axios.get('api/files?path=' + this.supplierOrder.receipt_path);
            window.open(url);
          } catch (e) {

          }
        }
      },
      openDeleteConfirmation() {
        this.$confirm('Ez a folyamat nem visszafordítható és a kapcsolódó elemek is törölve lesznek.', 'Biztosan törölni szeretnéd?', {
          confirmButtonText: 'Igen',
          cancelButtonText: 'Mégse',
          type: 'warning',
        })
        .then(() => {
          this.deleteSupplierOrder();
        })
        .catch(() => {
          this.$router.replace('/sales/supplier-orders');
        });
      },
      handleAction(action) {
        action();
      },
      toggleDropDown() {
        this.$refs['dropDown'].visible = !this.$refs['dropDown'].visible;
      },
      async exportExcel() {
        try {
          this.buttonLoader = true;
          const excel = await axios({
            url: 'api/supplier-orders/' + this.supplierOrder.id + '/export',
            method: 'GET',
            responseType: 'blob',
          });
          saveAs(excel, 'supplier_order_items.xlsx');
        } catch (e) {
        }
        this.buttonLoader = false;

      },
    }
  };
</script>
